import { type VectorLayer } from '@meitu/saas-editor-core/es/layers/vector-layer';
import { type IVectorLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { ColorGroup } from '@meitu/xdesign-widgets';
import { useEditor } from '@/hooks/use-editor';
import { useGlobalWidget } from '@/hooks/use-global-widget';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';
import { type WidgetCommonProps } from '../../types';
import { Tracker } from '../../utils';

type Props = WidgetCommonProps;

const FALLBACK_COLOR = '#000000ff';

export const TextColorPicker: React.FC<Props> = ({ layerId, recordId }) => {
    const editor = useEditor();
    const color = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;

        const layerData = layer.data as IVectorLayerProps;
        const { textInfo } = layerData;

        return textInfo ? textInfo.color : null;
    }) as string | null;

    const popoverWidgetRef = useGlobalWidget(editor, false);

    const setTextColor = (value: string, options = { writeHistory: true }) => {
        if (!color) return;

        editor.getInstance<VectorLayer>('VectorLayer').setTextColor(layerId, value, options);

        if (options.writeHistory) {
            Tracker.setTextColor({
                recordId,
                stageType: editor.services.editor.getCanvasType(),
                color: value,
                isVectorLayer: true,
            });
        }
    };

    const handleColorPickerOpenChange = (open: boolean) => {
        popoverWidgetRef.current = open;

        if (open) {
            Tracker.openTextColorPicker({
                recordId,
                stageType: editor.services.editor.getCanvasType(),
            });
        }
    };

    return (
        <ColorGroup
            placement="left"
            showIcon
            popupTriggerSize={{ width: 90, height: 34 }}
            color={color || FALLBACK_COLOR}
            setColor={(color) => setTextColor(color, { writeHistory: false })}
            setColorAfter={(color, _, { isBrandColor }) => {
                setTextColor(color, { writeHistory: true });
                if (isBrandColor) {
                    window._stat_track?.('hb_layers_func_use', {
                        func_id: '9_107',
                    });
                }
            }}
            onOpenChange={handleColorPickerOpenChange}
            onToggleBizTab={(bizTab) => {
                if (bizTab === 'team') {
                    window._stat_track?.('hb_layers_func_click', {
                        func_id: '1_107',
                    });
                }
            }}
            popupOverlayClassName="vector-panel-color-picker"
        />
    );
};
